/* ==========================================================================
   PBMEquine Homepage v2 — Shared JS (carousel + FAQ accordion)
   Deploy: Shopify theme assets/pbm-home.js
   Idempotent: safe to load more than once; re-inits on Shopify editor events.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Hero carousel ---- */
  function initHero(root) {
    if (!root || root.dataset.pbmHeroReady === '1') return;
    root.dataset.pbmHeroReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.pbm-slide'));
    var dots   = Array.prototype.slice.call(root.querySelectorAll('.pbm-dot'));
    if (slides.length === 0) return;

    var i = 0;
    var timer = null;
    var delay = parseInt(root.dataset.autoplay, 10) || 0; // ms; 0 = off

    function show(n) {
      slides[i].classList.remove('on');
      if (dots[i]) dots[i].classList.remove('on');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('on');
      if (dots[i]) dots[i].classList.add('on');
    }
    function move(d) { show(i + d); restart(); }
    function restart() {
      if (timer) clearInterval(timer);
      if (delay > 0 && slides.length > 1) timer = setInterval(function () { show(i + 1); }, delay);
    }

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { show(idx); restart(); });
    });
    var prev = root.querySelector('.pbm-arr-prev');
    var next = root.querySelector('.pbm-arr-next');
    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });

    // Pause on hover
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);

    restart();
  }

  function initAllHeroes(scope) {
    (scope || document).querySelectorAll('.pbm-hero').forEach(initHero);
  }

  /* ---- FAQ accordion (event delegation, attached once) ---- */
  function initFaqDelegation() {
    if (window.__pbmFaqBound) return;
    window.__pbmFaqBound = true;
    document.addEventListener('click', function (e) {
      var q = e.target.closest('.pbm-faq-q');
      if (!q) return;
      var item = q.parentElement;
      if (item && item.classList.contains('pbm-faq-i')) item.classList.toggle('open');
    });
  }

  /* ---- Boot ---- */
  function boot() { initAllHeroes(document); initFaqDelegation(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ---- Shopify theme editor: re-init a section when it loads ---- */
  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    initAllHeroes(target);
    initFaqDelegation();
  });
})();
